import { useEffect } from "react";
// import { ReactNode, useEffect } from "react";
import {
    useShow,
    IResourceComponentsProps,
    useTranslate,
    useUpdate,
    useOne,
    // useDelete,
    // useDeleteMany,
    // useSelect,
} from "@pankod/refine-core";
import {
    Row,
    Col,
    Button,
    DateField,
    Icons,
    Steps,
    PageHeader,
    Grid,
    Space,
    // Avatar,
    Typography,
    Card,
    // Table,
    // List,
    Skeleton,
    MarkdownField
} from "@pankod/refine-antd";

// import GoogleMapReact from "google-map-react";
// import dayjs from "dayjs";

// import { OrderStatus } from "components/salesStatus";

// import { MapMarker } from "../../components/map";
// import { BikeWhiteIcon } from "../../components/icons";
// import { BikeWhiteIcon, UserIcon, CourierIcon } from "../../components/icons";
// import { useOrderCustomKbarActions } from "../../hooks";
// import { IEvent, IOrder, IProduct } from "../../interfaces";
import { ISale, IOrganization, IStore } from "interfaces";

import "./style.less";
import 'highlight.js/styles/default.css';

import hljs from 'highlight.js';
import xml from 'highlight.js/lib/languages/xml';
hljs.registerLanguage('xml', xml);

const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

export const SaleShow: React.FC<IResourceComponentsProps> = () => {
  const t = useTranslate();
  const screens = useBreakpoint();
  const { queryResult } = useShow<ISale>();
  const { data } = queryResult;
  const { mutate } = useUpdate<ISale>();
  // const { mutate: mutateDeleteMany } = useDeleteMany<IOrder>();
  // const { mutate: mutateDelete} = useDelete<ISale>();

  const record = data?.data;

  const { data: organizationData, isLoading: organizationIsLoading } =
    useOne<IOrganization>({
      resource: "organizations",
      id: record?.organization_id || 0,
      // queryOptions: {
      //   enabled: !!record,
      // },
    });
  
  const { data: storeData, isLoading: storeIsLoading } =
    useOne<IStore>({
      resource: "stores",
      id: record?.store_id || 0,
      // queryOptions: {
      //   enabled: !!record,
      // },
    });
  
  const canAcceptOrder = 
    record?.status === "Ready" ||
    record?.status === "Pending";
  // const canAcceptOrder = record?.status.text === "Pending";
  // const canRejectOrder =
  //     record?.status.text === "Pending" ||
  //     record?.status.text === "Ready" ||
  //     record?.status.text === "On The Way";
  // const canDeleteSale = record?.status === "Cancelled";
  // const canDeleteSale = record?.status === "Cancelled" || organizationData?.data?.debug === true;
  
  const currentBreakPoints = Object.entries(screens)
    .filter((screen) => !!screen[1])
    .map((screen) => screen[0]);

  useEffect(() => {
    // hljs.initHighlighting();
    hljs.highlightAll();
  }, []);

  const renderOrderSteps = () => {
    // const notFinishedCurrentStep = (event: IEvent, index: number) =>
    //   event.status !== "Cancelled" &&
    //   event.status !== "Delivered" &&
    //   record?.events.findIndex(
    //     (el) => el.status === record?.status?.text,
    //   ) === index;

    // const stepStatus = (event: IEvent, index: number) => {
    //   if (!event.date) return "wait";
    //   if (event.status === "Cancelled") return "error";
    //   // if (notFinishedCurrentStep(event, index)) return "process";
    //   return "finish";
    // };

    const handleMutate = (value: { id: number; status: string }) => {
      if (record) {
        mutate({
          resource: "sales",
          // id: record.id.toString(),
          id: record.id,
          values: {
            status: value.status,
          },
        });
      }
    };

    // const handleDelete = (id: number) => {
    //   if (record) {
    //     // mutateDeleteMany({
    //     //   resource: "orders",
    //     //   ids: [id],
    //     // });
    //     mutateDelete({
    //       resource: "sales",
    //       id: id,
    //     });
    //   }
    // };

    // useOrderCustomKbarActions(record);


    return (
      <PageHeader
        className="pageHeader"
        ghost={false}
        onBack={() => window.history.back()}
        title={t("sales.fields.title")}
        subTitle={`#${record?.title ?? ""}`}
        extra={[
          <Button
            disabled={canAcceptOrder}
            key="accept"
            // icon={<Icons.CheckCircleOutlined />}
            icon={<Icons.FileSyncOutlined />}
            type="primary"
            onClick={() =>
              handleMutate({
                id: record?.id || 0,
                status: "Pending",
              })
            }
          >
            {t("buttons.process")}
          </Button>,
      //     <Button
      //       disabled={!canDeleteSale}
      //       key="reject"
      //       danger
      //       // icon={<Icons.CloseCircleOutlined />}
      //       icon={<Icons.DeleteOutlined />}
      //       // onClick={() => handleDelete(record?.id || 0)}
      //     >
      //       {t("buttons.delete")}
      //     </Button>,
        ]}
      >
        <Steps
          direction={
            currentBreakPoints.includes("lg")
              ? "horizontal"
              : "vertical"
          }
          // current={record?.events.findIndex(
          //   (el) => el.status === record?.status?.text,
          // )}
        >
          {/* {record?.events.map((event: IEvent, index: number) => (
            <Steps.Step
              status={stepStatus(event, index)}
              key={index}
              title={t(`enum.orderStatuses.${event.status}`)}
              icon={
                notFinishedCurrentStep(event, index) && (
                  <Icons.LoadingOutlined />
                )
              }
              description={
                  event.date && dayjs(event.date).format("L LT")
              }
            />
          ))} */}
        </Steps>
        {!record && <Skeleton paragraph={{ rows: 1 }} />}
      </PageHeader>
    );
  };

  const renderMessage = () => (
    record?.message && (
      <Card bordered={false} title={t("notifications.messageErrors")} style={{marginBottom: "10px"}}>
      <MarkdownField value={record.message} />
    </Card>
    )
  );

  const renderOrderStatus = () => (
    // const st = record?.status || "Pending";
    record?.status && (
      <>
        <Title level={5}>
          {t("sales.fields.status")}
        </Title>
        <Text>{t(`enum.orderStatuses.${record.status}`)}</Text>
      </>
    )
  );

  const renderOrganization = () => (
      organizationIsLoading ? `{t("loading")}...` : (
      <>
        <Title level={5}>{t("stores.fields.organizations")}</Title>
        <Text>{organizationData?.data?.title}</Text>
      </>
    )
  );

  const renderStore = () => (
    storeIsLoading ? `{t("loading")}...` : (
      <>
        <Title level={5}>{t("sales.fields.store")}</Title>
        <Text>{storeData?.data?.title}</Text>
      </>
    )
  );

  const renderSaleDate = () => (
    record?.sales_date !== "0001-01-01" && (
      <>
        <Title level={5}>{t("sales.fields.salesDate")}</Title>
        <DateField value={record?.sales_date} format="LL" />
      </>
    )
  );

  const renderXmlData = () => (
    record?.data && (
      <Card bordered={false} title={t("sales.fields.data")}>
      <pre>
        <code className='xml'>
          {record.data}
        </code>
      </pre>
    </Card>
    )
  );

  // console.log(record);
  // console.log(record?.sales_date);
  // console.log(queryResult);
  
  return (
    <>
      <Space size={20} direction="vertical" style={{ width: "100%" }}>
        {renderOrderSteps()}
        <Row gutter={[16, 16]}>
          <Col xl={6} lg={24} xs={24}>
            <Card bordered={false}>
              <Title level={5}>{t("sales.fields.code")}</Title>
              <Text>{record?.code}</Text>
              {renderOrderStatus()}
              {renderOrganization()}
              {renderStore()}
              {renderSaleDate()}
              <Title level={5}>{t("sales.fields.createdAt")}</Title>
              <DateField value={record?.created_at} format="LLL" />
            </Card>
          </Col>
          <Col xl={18} xs={24}>
            {renderMessage()}
            {renderXmlData()}
          </Col>
        </Row>
        {/* {renderCourierInfo()} */}
      </Space>
      {/* {renderDeliverables()} */}
    </>
  );
};
